import {useTranslation} from 'react-i18next';

import {useApplicantCulturePage} from './useApplicantCulturePage';
import {LockedCultureTypeBanner} from '../../../components/Banner/LockedCultureTypeBanner/LockedCultureTypeBanner';
import {ErrorMessage} from '../../../components/ErrorMessage/ErrorMessage';
import {LoadingContainer} from '../../../components/Loading/LoadingContainer';
import PageHeader from '../../../components/PageHeader/PageHeader';
import CultureTypeInformation from '../../../features/company/culture/dashboard/components/CultureTypeInformation/CultureTypeInformation';

export const ApplicantCulturePage = () => {
  const {t} = useTranslation();
  const {cultureInformation, loading, error} = useApplicantCulturePage();

  if (error) {
    return <ErrorMessage />;
  }

  return (
    <div>
      <PageHeader text={t('applicantCultureDashboard.title')} />
      {loading ? (
        <LoadingContainer minHeight={'400px'} />
      ) : (
        <>
          {cultureInformation ? (
            <CultureTypeInformation cultureInformation={cultureInformation} alwaysExpanded />
          ) : (
            <LockedCultureTypeBanner />
          )}
        </>
      )}
    </div>
  );
};
